import { render, staticRenderFns } from "./centerArea.vue?vue&type=template&id=df3605da"
import script from "./centerArea.vue?vue&type=script&lang=js"
export * from "./centerArea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports